export default __webpack_public_path__ + "static/media/2023_September_Wiese.050a4fd1.webp";